import {cloneDeep, findIndex, get, isNil, uniqBy} from "lodash";
import {CurveType} from "../constans/feedingTypes";
import {SettingTypes} from "../constans/settingTypes";
// import store from "../store/store";

export const initialValue = {
    feedingCurves: [],
    feedingSchedules: [],
    forage: [],
    forageHistory: [],
    settings: [],
    plan: undefined,
    general: undefined,
    showAppConf: false,
    economy: undefined,
    farmMap: new Map(),
    endpointArn: null,
    fetching: false,
    updating: false,
    adding: false,
    climateCurves: [],
    climateCurvesSK3: [],
    scheduleWorktypes: [],
    systemSchedules: [],
    file: null,
    ocrTemplates: [],
    protocol: {
        data: null,
        loading: false,
    },
    economySettings: null,
    customTasks: [],
    herdSettings: null,
    routines: [],
    technologyGroupTasks: null,
    cardTemplates: [],
    permissionTemplates: [],
    technologyGroupsForYears: [],
};

export default function settingsReducer(state = initialValue, action) {
    switch (action.type) {
        case "CHANGE_SHOW_AREA_CONFIG":
            return {
                ...state,
                showAreaConfig: action.payload,
                showDevicesConfig: false,
                showNotifications: false,
                showLicense: false,
                showSMS: false,
                showEmail: false,
                showAppConf: false,
            };
        case "CHANGE_SHOW_DEVICES_CONFIG":
            return {
                ...state,
                showAreaConfig: false,
                showDevicesConfig: action.payload,
                showNotifications: false,
                showLicense: false,
                showSMS: false,
                showEmail: false,
                showAppConf: false,
            };
        case "CHANGE_SHOW_NOTIFICATIONS":
            return {
                ...state,
                showAreaConfig: false,
                showDevicesConfig: false,
                showNotifications: action.payload,
                showLicense: false,
                showSMS: false,
                showEmail: false,
                showAppConf: false,
            };
        case "CHANGE_SHOW_SMS":
            return {
                ...state,
                showSMS: action.payload,
                showEmail: false,
                showAppConf: false,
            };
        case "CHANGE_SHOW_EMAIL":
            return {
                ...state,
                showEmail: action.payload,
                showSMS: false,
                showAppConf: false,
            };
        case "CHANGE_SHOW_APP_CONF":
            return {
                ...state,
                showAppConf: action.payload,
                showEmail: false,
                showSMS: false,
            };
        case "CHANGE_SHOW_LICENSE":
            return {
                ...state,
                showAreaConfig: false,
                showDevicesConfig: false,
                showNotifications: false,
                showLicense: action.payload,
                showSMS: false,
                showEmail: false,
                showAppConf: false,
            };
        case "CHANGE_SHOW_PAYMENT_METHODS":
            return {
                ...state,
                showPaymentMethods: action.payload,
                showSubscriptions: false,
            };
        case "CHANGE_SHOW_SUBSCRIPTIONS":
            return {
                ...state,
                showPaymentMethods: false,
                showSubscriptions: action.payload,
            };
        case "CLOSE_ALL_TABS":
            return {
                ...state,
                showAreaConfig: false,
                showDevicesConfig: false,
                showNotifications: false,
                showLicense: false,
                showSMS: false,
                showEmail: false,
                showAppConf: false,
                showPaymentMethods: false,
                showSubscriptions: false,
            };
        case "CHANGE_FARM":
        case "USER_LOGOUT_FULFILLED": {
            return initialValue;
        }
        case "GET_PERMISSIONS_FULFILLED":
        case "GET_PERMISSIONS": {
            let tmp = cloneDeep(action.payload);
            let permissionTemplates = tmp.filter(
                (set) => set.SetType === SettingTypes.PERMISSION_TEMPLATES
            );
            return {
                ...state,
                permissionTemplates,
            };
        }

        case "LIST_ALL_SETTINGS": {
            let tmp = action.payload.slice();
            //sortowanko zeby uniqBy bral najnowsze rzeczy jak sie powtarzaja na dynamo
            tmp.sort((o1, o2) => +o2.DtaModTime - +o1.DtaModTime);
            const curves = [],
                schedules = [],
                forage = [],
                forageHistory = [],
                climateCurvesSK3 = [],
                climateCurves = [],
                scheduleWorktypes = [],
                systemSchedules = [],
                ocrTemplates = [],
                customTasks = [],
                routines = [],
                cardTemplates = [],
                permissionTemplates = [],
                technologyGroupsForYears = [];
            let plan,
                general,
                economy,
                file,
                economySettings,
                herdSettings,
                technologyGroupTasks;
            let tmpFarmMap = new Map();
            for (let row of tmp) {
                switch (row.SetType) {
                    case SettingTypes.FEEDING_CURVE:
                        if (
                            get(row, "SetData.Index") !== undefined &&
                            Object.values(CurveType).includes(row.SetData.Type)
                        ) {
                            curves.push(row);
                        }
                        break;
                    case SettingTypes.FEEDING_SCHEDULE:
                        if (get(row, "SetData.Index") !== undefined) {
                            schedules.push(row);
                        }
                        break;
                    case SettingTypes.YEARLY_PLANS:
                        if (!plan) plan = row;
                        break;
                    case SettingTypes.FEEDING_FORAGE:
                        if (!row.DtaDelTime) {
                            forage.push(row);
                        } else {
                            forageHistory.push(row);
                        }
                        break;
                    case SettingTypes.GENERAL:
                        if (row.SetID === `${row.ClientID}_${row.FarmID}`) {
                            general = row;
                        }
                        break;
                    case SettingTypes.FARM_MAP:
                        if (row.SetData && row.SetData.Levels) {
                            if (row.SetID.startsWith("farm_map_")) {
                                tmpFarmMap.set(
                                    row.SetID.replace("farm_map_", ""),
                                    row
                                );
                            }
                        }
                        break;
                    case SettingTypes.ECONOMY:
                        economy = row;
                        break;
                    case SettingTypes.CLIMATE_SK3_CURVE:
                        if (!isNil(row.SetData.Index)) {
                            climateCurvesSK3.push(row);
                        }
                        break;
                    case SettingTypes.CLIMATE_CURVE:
                        climateCurves.push(row);
                        break;
                    case SettingTypes.SYSTEM_SCHEDULE_WORKTYPE:
                        scheduleWorktypes.push(row);
                        break;
                    case SettingTypes.SYSTEM_SCHEDULE:
                        systemSchedules.push(row);
                        break;
                    case SettingTypes.FILE:
                        file = row;
                        break;
                    case SettingTypes.OCR_TEMPLATE:
                        ocrTemplates.push(row);
                        break;
                    case SettingTypes.ECONOMY_SETTINGS:
                        economySettings = row;
                        break;
                    case SettingTypes.HERD_SETTINGS:
                        herdSettings = row;
                        break;
                    case SettingTypes.CUSTOM_TASKS:
                        customTasks.push(row);
                        break;
                    case SettingTypes.ROUTINES:
                        routines.push(row);
                        break;
                    case SettingTypes.TECHNOLOGY_GROUP_TASKS:
                        technologyGroupTasks = row;
                        break;
                    case SettingTypes.CARD_TEMPLATES:
                        if (!row.DtaDelTime) {
                            cardTemplates.push(row);
                        }
                        break;
                    case SettingTypes.PERMISSION_TEMPLATES:
                        permissionTemplates.push(row);
                        break;
                    case SettingTypes.TECHNOLOGY_GROUP_YEAR:
                        technologyGroupsForYears.push(row);
                        break;
                    default:
                        console.log("Unknown row", row);
                }
            }
            return {
                ...state,
                settings: tmp,
                feedingCurves: uniqBy(curves, (o) => get(o, "SetData.Index")),
                feedingSchedules: uniqBy(schedules, (o) =>
                    get(o, "SetData.Index")
                ),
                plan: plan,
                forage: forage,
                forageHistory: forageHistory,
                general: general,
                fetching: false,
                farmMap: tmpFarmMap,
                economy: economy,
                climateCurves: climateCurves,
                scheduleWorktypes,
                systemSchedules,
                climateCurvesSK3: uniqBy(climateCurvesSK3, (o) =>
                    get(o, "SetData.Index")
                ),
                file,
                ocrTemplates,
                economySettings,
                herdSettings,
                customTasks,
                routines,
                technologyGroupTasks,
                cardTemplates,
                permissionTemplates,
                technologyGroupsForYears,
            };
        }

        case "CREATE_SETTING_PENDING": {
            return {
                ...state,
                adding: true,
            };
        }
        case "CREATE_SETTING_REJECTED":
        case "CREATE_SETTING_FULFILLED": {
            return {
                ...state,
                adding: false,
            };
        }
        case "UPDATE_SETTING_PENDING": {
            return {
                ...state,
                updating: true,
            };
        }
        case "UPDATE_SETTING_REJECTED":
        case "UPDATE_SETTING_FULFILLED": {
            return {
                ...state,
                updating: false,
            };
        }
        case "GET_SETTINGS_PENDING": {
            return {
                ...state,
                fetching: true,
            };
        }
        case "GET_SETTINGS_REJECTED":
        case "GET_SETTINGS_FULFILLED": {
            return {
                ...state,
                fetching: false,
            };
        }
        case "GET_COMMISSIONING_PROTOCOL_PENDING":
            return {...state, protocol: {...state.protocol, loading: true}};
        case "GET_COMMISSIONING_PROTOCOL_FULFILLED":
            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    loading: false,
                    data: action.payload,
                },
            };
        case "GET_COMMISSIONING_PROTOCOL_REJECTED":
            return {...state, protocol: {...state.protocol, loading: false}};
        case "ADD_NEW_CURVE_OFFLINE": {
            const currentCurves = state.feedingCurves.slice();
            const currentSettings = state.settings.slice();
            currentCurves.push(action.payload);
            currentSettings.push(action.payload);
            return {
                ...state,
                feedingCurves: currentCurves,
                settings: currentSettings,
            };
        }
        case "UPDATE_CURVE_OFFLINE": {
            const currentCurves = state.feedingCurves.slice();
            let curveIndex = findIndex(
                currentCurves,
                (o) => o.SetID === action.payload.SetID
            );
            currentCurves.splice(curveIndex, 1);
            currentCurves.push(action.payload);
            const currentSettings = state.settings.slice();
            let settingsIndex = findIndex(
                currentSettings,
                (o) => o.SetID === action.payload.SetID
            );
            currentSettings.splice(settingsIndex, 1);
            currentSettings.push(action.payload);
            return {
                ...state,
                feedingCurves: currentCurves,
                settings: currentSettings,
            };
        }
        case "ADD_NEW_SCHEDULE_OFFLINE": {
            const currentSchedules = state.feedingSchedules.slice();
            const currentSettings = state.settings.slice();
            currentSchedules.push(action.payload);
            currentSettings.push(action.payload);
            return {
                ...state,
                feedingSchedules: currentSchedules,
                settings: currentSettings,
            };
        }
        case "UPDATE_SCHEDULE_OFFLINE": {
            const currentSchedules = state.feedingSchedules.slice();
            let curveIndex = findIndex(
                currentSchedules,
                (o) => o.SetID === action.payload.SetID
            );
            currentSchedules.splice(curveIndex, 1);
            currentSchedules.push(action.payload);
            const currentSettings = state.settings.slice();
            let settingsIndex = findIndex(
                currentSettings,
                (o) => o.SetID === action.payload.SetID
            );
            currentSettings.splice(settingsIndex, 1);
            currentSettings.push(action.payload);
            return {
                ...state,
                feedingSchedules: currentSchedules,
                settings: currentSettings,
            };
        }
        case "ADD_NEW_CLIMATE_CURVE_OFFLINE": {
            const currentCurves = state.climateCurvesSK3.slice();
            const currentSettings = state.settings.slice();
            currentCurves.push(action.payload);
            currentSettings.push(action.payload);
            return {
                ...state,
                climateCurvesSK3: currentCurves,
                settings: currentSettings,
            };
        }
        case "UPDATE_CLIMATE_CURVE_OFFLINE": {
            const currentCurves = state.climateCurvesSK3.slice();
            let curveIndex = findIndex(
                currentCurves,
                (o) => o.SetID === action.payload.SetID
            );
            currentCurves.splice(curveIndex, 1);
            currentCurves.push(action.payload);
            const currentSettings = state.settings.slice();
            let settingsIndex = findIndex(
                currentSettings,
                (o) => o.SetID === action.payload.SetID
            );
            currentSettings.splice(settingsIndex, 1);
            currentSettings.push(action.payload);
            return {
                ...state,
                climateCurvesSK3: currentCurves,
                settings: currentSettings,
            };
        }
        case "SHOW_EDIT_PERMISSION_MODAL":
            return {
                ...state,
                showEditPermissionModal: true,
                currentPermission: action.payload,
            };
        case "HIDE_EDIT_PERMISSION_MODAL":
            return {
                ...state,
                showEditPermissionModal: false,
                currentPermission: null,
            };
        default:
            return state;
    }
}
